/**
 * Icone d'onglet, propre au restaurant affiche.
 *
 * Identique dans son principe a apps/web-client/src/lib/display-context.ts
 * (`applyFavicon`) : le logo du restaurant remplace l'icone Scan2Eat par
 * defaut des qu'il est connu, et inversement des qu'il ne l'est plus --
 * un administrateur de plateforme qui bascule entre restaurants voit ainsi
 * l'onglet suivre, sans etat partage entre onglets differents.
 */

const DEFAULT_FAVICON = '/favicon.svg';

export function applyFavicon(logoUrl: string | null | undefined): void {
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = logoUrl ?? DEFAULT_FAVICON;
}
